import { Routes } from '@angular/router';
import { EcommerceComponent } from './pages/dashboard/ecommerce/ecommerce.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { FormElementsComponent } from './pages/forms/form-elements/form-elements.component';
import { BasicTablesComponent } from './pages/tables/basic-tables/basic-tables.component';
import { BlankComponent } from './pages/blank/blank.component';
import { NotFoundComponent } from './pages/other-page/not-found/not-found.component';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { InvoicesComponent } from './pages/invoices/invoices.component';
import { LineChartComponent } from './pages/charts/line-chart/line-chart.component';
import { BarChartComponent } from './pages/charts/bar-chart/bar-chart.component';
import { AlertsComponent } from './pages/ui-elements/alerts/alerts.component';
import { AvatarElementComponent } from './pages/ui-elements/avatar-element/avatar-element.component';
import { BadgesComponent } from './pages/ui-elements/badges/badges.component';
import { ButtonsComponent } from './pages/ui-elements/buttons/buttons.component';
import { ImagesComponent } from './pages/ui-elements/images/images.component';
import { VideosComponent } from './pages/ui-elements/videos/videos.component';
import { CalenderComponent } from './pages/calender/calender.component';
import { UsuariosComponent } from './pages/usuarios/usuarios.component';
import { UsuarioEditComponent } from './pages/usuarios/usuario-edit/usuario-edit.component';
import { UsuariosRolesComponent } from './pages/usuarios/usuarios-roles/usuarios-roles.component';
import { ClientesComponent } from './pages/clientes/clientes.component';
import { ClienteEditComponent } from './pages/clientes/cliente-edit/cliente-edit.component';
import { ClienteAnunciantesComponent } from './pages/clientes/cliente-anunciantes/cliente-anunciantes.component';
import { OrdenesComponent } from './pages/ordenes/ordenes.component';
import { OrdenEditComponent } from './pages/ordenes/orden-edit/orden-edit.component';
import { TarifasComponent } from './pages/tarifas/tarifas.component';
import { TarifaEditComponent } from './pages/tarifas/tarifa-edit/tarifa-edit.component';
import { ProgramasComponent } from './pages/programas/programas.component';
import { ProgramaEditComponent } from './pages/programas/programa-edit/programa-edit.component';

import { TiposMaterialComponent } from './pages/tipos-material/tipos-material.component';
import { TipoMaterialEditComponent } from './pages/tipos-material/tipo-material-edit/tipo-material-edit.component';
import { RubrosComponent } from './pages/rubros/rubros.component';
import { RubroEditComponent } from './pages/rubros/rubro-edit/rubro-edit.component';
import { MaterialesComponent } from './pages/materiales/materiales.component';
import { MaterialEditComponent } from './pages/materiales/material-edit/material-edit.component';
import { TipoProductosComponent } from './pages/tipo-productos/tipo-productos.component';
import { TipoProductoEditComponent } from './pages/tipo-productos/tipo-producto-edit/tipo-producto-edit.component';
import { FormatosDigitalesComponent } from './pages/formatos-digitales/formatos-digitales.component';
import { FormatoDigitalEditComponent } from './pages/formatos-digitales/formato-digital-edit/formato-digital-edit.component';
import { UbicacionesDigitalesComponent } from './pages/ubicaciones-digitales/ubicaciones-digitales.component';
import { UbicacionDigitalEditComponent } from './pages/ubicaciones-digitales/ubicacion-digital-edit/ubicacion-digital-edit.component';
import { AnalyticsComponent } from './pages/analytics/analytics.component';
import { ReportesComponent } from './pages/reportes/reportes.component';

// Guards
import { authGuard } from './services/guards/auth.guard';
import { adminGuard } from './services/guards/admin.guard';
import { roleGuard } from './services/guards/role.guard';
import { defaultPasswordGuard } from './services/guards/default-password.guard';

export const routes: Routes = [
  // Rutas de autenticación (sin guard)
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.routes').then(m => m.authRoutes),
    title: 'Autenticación | Sistema LT10'
  },
  
  // Rutas principales (con guard de autenticación)
  {
    path: '',
    component: AppLayoutComponent,
    canActivate: [authGuard, defaultPasswordGuard],
    children: [
      {
        path: '',
        component: EcommerceComponent,
        pathMatch: 'full',
        title: 'Dashboard | Sistema LT10'
      },
      {
        path: 'calendar',
        component: CalenderComponent,
        title: 'Calendario | Sistema LT10'
      },
      {
        path: 'profile',
        component: ProfileComponent,
        title: 'Perfil | Sistema LT10'
      },
      {
        path: 'form-elements',
        component: FormElementsComponent,
        title: 'Elementos de Formulario | Sistema LT10'
      },
      {
        path: 'basic-tables',
        component: BasicTablesComponent,
        title: 'Tablas Básicas | Sistema LT10'
      },
      {
        path: 'blank',
        component: BlankComponent,
        title: 'Página en Blanco | Sistema LT10'
      },
      {
        path: 'invoice',
        component: InvoicesComponent,
        title: 'Facturas | Sistema LT10'
      },
      {
        path: 'line-chart',
        component: LineChartComponent,
        title: 'Gráfico de Líneas | Sistema LT10'
      },
      {
        path: 'bar-chart',
        component: BarChartComponent,
        title: 'Gráfico de Barras | Sistema LT10'
      },
      {
        path: 'alerts',
        component: AlertsComponent,
        title: 'Alertas | Sistema LT10'
      },
      {
        path: 'avatars',
        component: AvatarElementComponent,
        title: 'Avatares | Sistema LT10'
      },
      {
        path: 'badge',
        component: BadgesComponent,
        title: 'Insignias | Sistema LT10'
      },
      {
        path: 'buttons',
        component: ButtonsComponent,
        title: 'Botones | Sistema LT10'
      },
      {
        path: 'images',
        component: ImagesComponent,
        title: 'Imágenes | Sistema LT10'
      },
      {
        path: 'videos',
        component: VideosComponent,
        title: 'Videos | Sistema LT10'
      },
      // Rutas de usuarios (solo para administradores)
      {
        path: 'usuarios',
        component: UsuariosComponent,
        canActivate: [adminGuard],
        title: 'Usuarios | Sistema LT10'
      },
      {
        path: 'usuarios/edit/:id',
        component: UsuarioEditComponent,
        canActivate: [adminGuard],
        title: 'Editar Usuario | Sistema LT10'
      },
      {
        path: 'usuarios/roles',
        component: UsuariosRolesComponent,
        canActivate: [adminGuard],
        title: 'Gestión de Roles | Sistema LT10'
      },
      // Rutas de clientes
      {
        path: 'clientes',
        component: ClientesComponent,
        title: 'Clientes | Sistema LT10'
      },
      {
        path: 'ordenes',
        component: OrdenesComponent,
        title: 'Órdenes | Sistema LT10'
      },
      {
        path: 'ordenes/nueva',
        component: OrdenEditComponent,
        title: 'Nueva Orden | Sistema LT10'
      },
      {
        path: 'ordenes/:id/editar',
        component: OrdenEditComponent,
        title: 'Editar Orden | Sistema LT10'
      },
      {
        path: 'clientes/edit/:id',
        component: ClienteEditComponent,
        title: 'Editar Cliente | Sistema LT10'
      },
      {
        path: 'clientes/:id/anunciantes',
        component: ClienteAnunciantesComponent,
        title: 'Gestión de Anunciantes | Sistema LT10'
      },
      // Rutas de tarifas
      {
        path: 'tarifas',
        component: TarifasComponent,
        title: 'Tarifas | Sistema LT10'
      },
      {
        path: 'tarifas/edit/:id',
        component: TarifaEditComponent,
        title: 'Editar Tarifa | Sistema LT10'
      },
      // Rutas de programas
      {
        path: 'programas',
        component: ProgramasComponent,
        title: 'Programas | Sistema LT10'
      },
      {
        path: 'programas/edit/:id',
        component: ProgramaEditComponent,
        title: 'Editar Programa | Sistema LT10'
      },
      {
        path: 'programacion-diaria',
        loadComponent: () => import('./pages/programacion-diaria/programacion-diaria.component').then(m => m.ProgramacionDiariaComponent),
        title: 'Programación Diaria | Sistema LT10'
      },
      {
        path: 'programacion',
        loadComponent: () => import('./pages/programacion-grilla/programacion-grilla.component').then(m => m.ProgramacionGrillaComponent),
        title: 'Ver Programación | Sistema LT10'
      },

      // Rutas de tipos de material
      {
        path: 'tipos-material',
        component: TiposMaterialComponent,
        title: 'Tipos de Material | Sistema LT10'
      },
      {
        path: 'tipos-material/edit/:id',
        component: TipoMaterialEditComponent,
        title: 'Editar Tipo de Material | Sistema LT10'
      },
      // Rutas de rubros
      {
        path: 'rubros',
        component: RubrosComponent,
        title: 'Rubros | Sistema LT10'
      },
      {
        path: 'rubros/edit/:id',
        component: RubroEditComponent,
        title: 'Editar Rubro | Sistema LT10'
      },
      // Rutas de materiales
      {
        path: 'materiales',
        component: MaterialesComponent,
        title: 'Materiales | Sistema LT10'
      },
      {
        path: 'materiales/edit/:id',
        component: MaterialEditComponent,
        title: 'Editar Material | Sistema LT10'
      },
      // Rutas de tipos de producto
      {
        path: 'tipo-productos',
        component: TipoProductosComponent,
        title: 'Tipos de Producto | Sistema LT10'
      },
      {
        path: 'tipo-productos/edit/:id',
        component: TipoProductoEditComponent,
        title: 'Editar Tipo de Producto | Sistema LT10'
      },
      // Rutas de formatos digitales
      {
        path: 'formatos-digitales',
        component: FormatosDigitalesComponent,
        title: 'Formatos Digitales | Sistema LT10'
      },
      {
        path: 'formatos-digitales/edit/:id',
        component: FormatoDigitalEditComponent,
        title: 'Editar Formato Digital | Sistema LT10'
      },
      // Rutas de ubicaciones digitales
      {
        path: 'ubicaciones-digitales',
        component: UbicacionesDigitalesComponent,
        title: 'Ubicaciones Digitales | Sistema LT10'
      },
      {
        path: 'ubicaciones-digitales/edit/:id',
        component: UbicacionDigitalEditComponent,
        title: 'Editar Ubicación Digital | Sistema LT10'
      },
      {
        path: 'analytics',
        component: AnalyticsComponent,
        title: 'Analytics | Sistema LT10'
      },
      {
        path: 'reportes',
        component: ReportesComponent,
        title: 'Reportes | Sistema LT10'
      },
    ]
  },
  
  // Redirección a login si no está autenticado
  {
    path: 'signin',
    redirectTo: '/auth/login',
    pathMatch: 'full'
  },
  {
    path: 'signup',
    redirectTo: '/auth/register',
    pathMatch: 'full'
  },
  
  // Página no encontrada
  {
    path: '**',
    component: NotFoundComponent,
    title: 'Página No Encontrada | Sistema LT10'
  },
];
